// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInWithGmailMutationVariables = Types.Exact<{
  input: Types.SignInWithGmailInput;
}>;


export type SignInWithGmailMutation = { __typename?: 'Mutation', signInWithGmail: { __typename?: 'AuthResult', accessToken: string } };


export const SignInWithGmailDocument = /*#__PURE__*/ gql`
    mutation SignInWithGmail($input: SignInWithGmailInput!) {
  signInWithGmail(input: $input) {
    accessToken
  }
}
    `;

/**
 * __useSignInWithGmailMutation__
 *
 * To run a mutation, you first call `useSignInWithGmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithGmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithGmailMutation, { data, loading, error }] = useSignInWithGmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInWithGmailMutation(baseOptions?: Apollo.MutationHookOptions<SignInWithGmailMutation, SignInWithGmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInWithGmailMutation, SignInWithGmailMutationVariables>(SignInWithGmailDocument, options);
      }
export type SignInWithGmailMutationHookResult = ReturnType<typeof useSignInWithGmailMutation>;